/**
 * When returning props from getServerSideProps, we want to filter out any props that are falsy.
 * This is due to the serialization process in Next.js, which does not handle undefined or null values well.
 * @param {*} props 
 * @returns 
 */
export const filteredServerSideProps = (props) => {
  return Object.entries(props).reduce((acc, [key, value]) => {
    if (value) acc[key] = value
    return acc
  }, {})
}
